module.exports = __webpack_public_path__ + "media/media/favicon/apple-touch-icon-48fe1566818ceac2ec21361870c52dda.png";